import { capitalize } from "lodash";
import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { FilterFamily } from "PFTypes";
import { FiltersConfigTemplateElement } from "PFTypes/filters_config";
import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Filter } from "../filter";
import { useDefaultFilterFields } from "./hooks/use_default_filter_fields";
import css from "./sections.module.scss";

type SectionProps = {
  filterFamily: FilterFamily;
  template: FiltersConfigTemplateElement;
};

export const Section = ({ filterFamily, template }: SectionProps) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const defaultFilterFields = useDefaultFilterFields(template);

  const { fields, append, remove } = useFieldArray({
    control,
    name: filterFamily
  });

  const handleAddFilter = (event) => {
    event.preventDefault();
    append(defaultFilterFields);
  };

  const handleRemove = (index: number) => remove(index);

  return (
    <div>
      <Typography variant="h2">{capitalize(filterFamily)}</Typography>
      <div className={css.filtersList}>
        {fields.map((field, index) => (
          <Filter
            filterFamily={filterFamily}
            key={field.id}
            index={index}
            onRemove={handleRemove}
            template={template}
          />
        ))}
        <Button kind="secondary" onClick={handleAddFilter} icon="add" text={t("add")} />
      </div>
    </div>
  );
};
